import React from 'react'
import Card from '../../Card/Card'
import HowItWorks from '../../HowItWorks/HowItWorks'
import SimpleCard from '../../Feedback/feedback'
import { Link, withRouter } from 'react-router-dom';

function WhySellToUs(props) {
  return (
    < div className=' p-2 mb-2'>
    
    <div style={{backgroundColor: "",}}className='bg-light p-2'>
              <span style={{fontSize:22, fontWeight:800, textAlign:"left", margin:20, }}>  Why trade in with us? </span>
              <div className='grid-container '>
              <div style={{ backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray", backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/data_protection")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat"}}   className='grid-item'>
               
                <div className='mt-10'>
                <span style={{fontSize:17, fontWeight:600, textAlign:"center"}}>Benefit of selling your device to us.</span>
                <hr></hr>
                <ul>
                  <li>We ensure to erase and factory reset your device (s) by data scrubbing and permanetly deleting any data on it.</li>
                  <li><span className="text-dark">We are pioneer in e-waste recycling.</span></li>
                  <li>Safest way to recycle your old electronics and get paid for it.</li>
                  <li>We use cutting-edge technology to recycle your devices.</li>
                </ul>
                </div>
                   </div>
                     
                    <div style={{backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray",backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/seamless_process")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat", }}   className='grid-item'>
                   <div className='mt-10'>
                   <span style={{fontSize:17, fontWeight:600, textAlign:"left", }}>Smart and secure way to recycle your old devices.</span>
                    <hr></hr>
                    <ul>
                    <li>We offer a very convenient and secure platform to sell your device (s).</li>
                    <li>You can know the worth of your devices in less than a minute.</li>
                    <li>Ship your device at your convenience.</li>
                    <li>Get updates on every step your trad in takes.</li>
                    <li>Get paid instantly via your preferred payment method—Cash, E-transfer (Interac), or PayPal.</li>
                  </ul>
                   </div>
                    
                    </div>
                      
                    <div style={{backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray",backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/semaless_process_2")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat", }}   className='grid-item'>
                    <div className='mt-10'>
                    <span style={{fontSize:17, fontWeight:600, textAlign:"left", }}>Secure and hassle-free process.</span>
                    <hr></hr>
                    <ul>
                    <li><span className="text-dark">We provide WhatsApp chat-based customer support, along with 10–5 phone support.</span></li>
                    <li><span className="text-dark">We make sure to resolve any issue within a day.</span></li>
                    <li><span className="text-dark">Our customer support team consists of trained professionals, experts at resolving customer issues and providing the best possible solutions.</span></li>
                    <li>We offer the way to track status of your trade in any time.</li>
                  </ul> 
                  </div>
                    </div>
                    <div style={{backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray",backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/whyselltous/customer_support.png")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat", }}   className='grid-item'>
                    <div className='mt-10 '>
                    <span style={{fontSize:17, fontWeight:600, textAlign:"left", }}>Best customer support in the industry.</span>
                    <hr></hr>
                    <ul>
                    <li>We pay the best trade in value for your device (s) in the industry.</li>
                    <li>We pay in cash, not store credit.</li>
                    <li>We provide a prepaid shipping label so you can ship your devices to us free of charge.</li>
                    <li>We offer same-day payments upon receiving your device via your preferred method (Interac, cash, PayPal).</li>
                    <li>
                      We offer a fast and easy way to check your device’s value. 
                      <Link className="text-danger cursor-pointer" to="/SellAdevice">
                        <u> Find out the worth of your device</u>
                     </Link>
                    </li>
                   
                  </ul>
                  </div>
                   </div>
                
              </div> 
            </div>
    <div>
      
      <HowItWorks/>
    </div>
    <div>
      <SimpleCard/>
    </div>
   
    </div>
    
    
  )
}

export default WhySellToUs
